module.exports = __webpack_public_path__ + "img/airplane-coins.png";